export default {
    approvals: "Schválení",
    delegates: "Delegáti",
    employees: "Zaměstnanci"
}